module.exports = __webpack_public_path__ + "img/knue_gallery10.47b0a308.jpg";